import { render, staticRenderFns } from "./TabFacilities.vue?vue&type=template&id=92c60810&scoped=true&"
import script from "./TabFacilities.vue?vue&type=script&lang=js&"
export * from "./TabFacilities.vue?vue&type=script&lang=js&"
import style0 from "./TabFacilities.vue?vue&type=style&index=0&id=92c60810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c60810",
  null
  
)

export default component.exports